import React from 'react';

import createBlockInputSection from './helpers/createBlockInputSection';
import { GfmLiquidHelperText } from './helpers/templatableHelperText';
import HideSectionInput from './special-inputs/HideSectionInput';

const TextSidebarForm = createBlockInputSection({
  title: 'Text block',
  inputs: [
    {
      type: 'text',
      props: {
        autofocus: true,
        autohighlight: true,
        rows: 5,
        label: 'Content',
        name: 'text',
        helperText: <GfmLiquidHelperText />,
      },
    },
    'color',
    'backgroundColor',
    'fontFamily',
    'fontSize',
    'fontWeight',
    'textAlign',
    'padding',
    HideSectionInput,
  ],
});

export default TextSidebarForm;
